"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_DATE = exports.MIN_DATE = exports.parse = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DATEFORMAT = "YYYY-MM-DD";
var valid_relative_range_components = ["days", "day", "weeks", "week", "months", "month", "years", "year", "quarters", "quarter"];
var MAX_DATE = "MAX_DATE";
var MIN_DATE = "MIN_DATE";

var parse = function parse(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var output = {
        from: options.min || MIN_DATE,
        to: options.max || MAX_DATE
    };

    if (!input || (typeof input === "undefined" ? "undefined" : _typeof(input)) !== "object") return output;

    if (input.from) output.from = (0, _moment2.default)(input.from, DATEFORMAT).format(DATEFORMAT);
    if (input.to) output.to = (0, _moment2.default)(input.to, DATEFORMAT).format(DATEFORMAT);
    if (!input.from && !input.to) {
        var relative_date_component = Object.keys(input).find(function (r) {
            return valid_relative_range_components.includes(r);
        });
        var is_last = input.last === true;
        if (relative_date_component && !is_last) {
            output.from = (0, _moment2.default)().subtract(input[relative_date_component], relative_date_component).format(DATEFORMAT);
        } else if (relative_date_component) {
            output.from = (0, _moment2.default)().startOf(relative_date_component).subtract(input[relative_date_component], relative_date_component).format(DATEFORMAT);
            output.to = (0, _moment2.default)().startOf(relative_date_component).subtract(1, "days").format(DATEFORMAT);
        }
    }

    return output;
};

exports.parse = parse;
exports.MIN_DATE = MIN_DATE;
exports.MAX_DATE = MAX_DATE;